import { render, staticRenderFns } from "./CardPacket.vue?vue&type=template&id=55d79faf&scoped=true&"
import script from "./CardPacket.vue?vue&type=script&lang=js&"
export * from "./CardPacket.vue?vue&type=script&lang=js&"
import style0 from "./CardPacket.vue?vue&type=style&index=0&id=55d79faf&prod&lang=sass&scoped=true&"
import style1 from "./CardPacket.vue?vue&type=style&index=1&id=55d79faf&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d79faf",
  null
  
)

export default component.exports